import React, { Component, PureComponent } from 'react';
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import TextField from 'material-ui/TextField';

import GeoMap from '../GeoMap/GeoMap';
import SelectMenu from '../UI/Select-f';
import SwitchToggle from '../UI/SwitchToggle-f';
import * as Colors from '../../utils/Color';

const styles = {
    errorStyle: {
        color: Colors.error,
    },
    underlineStyle: {
        borderColor: Colors.grey
    },
    underlineFocusStyle: {
        borderColor: Colors.primary
    },
    floatingLabelStyle: {
        fontWeight: 'bold',
        color: Colors.grey50
    },
    hintLabelStyle: {
        fontWeight: 'bold',
        color: Colors.grey50
    },
    floatingLabelFocusStyle: {
        color: Colors.grey50,
        fontSize: '18px'
    }
};

const validateBranches = value => {
    const keys = Object.keys(value);
    if (keys.length === 0) return false;

    let val = true;

    for (const key in value) {
        if (!value[key].zone || !value[key].address) {
            val = false;
            break;
        }
    }
    return val;
};

class BranchLocation extends PureComponent {

    state = {
        isMapShown: this.props.isMapShown,
        latLng: { lat: 24.774265, lng: 46.738586 }, // default
        address: ''
    };

    componentDidMount() {
        if (this.props.location.address && this.props.location.position) {
            this.setState({
                address: this.props.location.address,
                latLng: { lat: this.props.location.position.latitude, lng: this.props.location.position.longitude }
            })
        }
    }

    handleChange = (address, latLng) => {
        this.setState({ address });
        geocodeByAddress(address)
            .then(results => getLatLng(results[0]))
            .then(latLng => {
                this.setState({ latLng });
                const position = { latitude: latLng.lat, longitude: latLng.lng };
                this.props.setFieldValue(this.props.name + '[' + this.props.index + '].position', position);
                this.props.setFieldValue(this.props.name + '[' + this.props.index + '].address', address);
            })
            .catch(error => console.error('Error', error))

    };

    handleSelect = address => {
        geocodeByAddress(address)
            .then(results => getLatLng(results[0]))
            .then(latLng => {
                this.setState({ address, latLng });
                const position = { latitude: latLng.lat, longitude: latLng.lng };
                this.props.setFieldValue(this.props.name + '[' + this.props.index + '].position', position);
                this.props.setFieldValue(this.props.name + '[' + this.props.index + '].address', address);
            })
            .catch(error => console.error('Error', error))
    };

    componentDidUpdate() {
        this.setState({ isMapShown: this.props.isMapShown });
    }

    render() {
        const { index, locationsLength, location, error } = this.props;
        let addressErrorText = '';
        let zoneErrorText = '';
        if (error) {
            const errorObject = JSON.parse(error);
            if(error === '{}') {
                addressErrorText = 'This field is mandatory.';
                zoneErrorText = 'This field is mandatory.';
            }
            if (errorObject[index] &&  !errorObject[index].address) addressErrorText = 'This field is mandatory.';
            if (errorObject[index]&& !errorObject[index].zone) zoneErrorText = 'This field is mandatory.';
        }
        const isLastLocation = ( index === locationsLength - 1 );
        const isLocationsLengthLessThanOne = ( locationsLength !== 1 );
        const iconsClassName = ( isLocationsLengthLessThanOne ? "col-xs-2 pb-5" : "col-xs-1 pb-5" );
        const selectMenuClassName = ( isLocationsLengthLessThanOne && isLastLocation ? "col-xs-10" : "col-xs-11" );
        const cursorPointer = { cursor: 'pointer' };
        const selectMenuValue = this.props.values[this.props.name] && this.props.values[this.props.name][this.props.index]
            && this.props.values[this.props.name][this.props.index] && this.props.values[this.props.name][this.props.index].zone;
        const switchToggleValue = this.props.values[this.props.name]
            && this.props.values[this.props.name][this.props.index] && this.props.values[this.props.name][this.props.index].is_active;
        const map = this.state.isMapShown ? <GeoMap handleChange={ this.handleChange } latLng={ this.state.latLng } /> : null;
        let removeIcon = null;
        let icons;
        if (isLocationsLengthLessThanOne) {
            removeIcon = (
                <a className="color-red"
                   onClick={(e) => this.props.removeLocation(e, index)}
                   style={ cursorPointer }>
                    <i className="fa fa-times-circle font-xl px-15"></i>
                </a>
            );
        }

        if ( isLastLocation ) {
            icons = (
                <div className={ iconsClassName }>
                    <a onClick={(e) => this.props.addLocation(e, index + 1)} style={ cursorPointer }>
                        <i className="fa fa-plus-circle font-xl"></i>
                    </a>
                    { removeIcon }
                </div>
            );
        } else {
            icons = (
                <div className="col-xs-1 pb-5">
                    <a className="color-red" onClick={e => this.props.removeLocation(e, index)} style={ cursorPointer }>
                        <i className="fa fa-times-circle font-xl"></i>
                    </a>
                </div>
            );
        }


        return (
            <div className="text-field pt-20">

                <div className="row align-end">
                    { icons }
                    <div  className={ selectMenuClassName }>
                        { this.props.zones && <SelectMenu error={zoneErrorText}
                                                          value={ selectMenuValue }
                                                          onChange={ this.props.setFieldValue }
                                                          menu={ this.props.zones }
                                                          name={this.props.name + '[' + this.props.index + '].zone'}
                                                          floatingLabelText="Zona" /> }
                    </div>
                </div>

                <div className="with-abs-icon">

                    <PlacesAutocomplete value={ this.state.address }
                                        onChange={ this.handleChange }
                                        onSelect={ this.handleSelect } >

                        {({ getInputProps, suggestions, getSuggestionItemProps }) => (
                            <div>
                                <TextField disabled={this.props.disabled}
                                           errorText={ addressErrorText }
                                           hintStyle={ styles.hintLabelStyle }
                                           fullWidth={ true }
                                           className="text-field"
                                           floatingLabelText={ "Customer Branch " + location.name }
                                           underlineStyle={ styles.underlineStyle }
                                           underlineFocusStyle={ styles.underlineFocusStyle }
                                           floatingLabelFocusStyle={ styles.floatingLabelFocusStyle }
                                           floatingLabelFixed={"Customer Branch " + location.name}
                                           {...getInputProps({
                                               id: "customer_branch_location" + index + 1,
                                               floatingLabelFixed: true,
                                               className: 'location-search-input'
                                           })}
                                />

                                {suggestions.length > 0 ? <div className="autocomplete-dropdown-container">
                                    {suggestions.map(suggestion => {
                                        const className = suggestion.active ? 'suggestion-item--active' : 'suggestion-item';
                                        // inline style for demonstration purpose
                                        const style = suggestion.active
                                            ? { backgroundColor: '#e5e5e5', cursor: 'pointer' }
                                            : { backgroundColor: '#ffffff', cursor: 'pointer' };
                                        return (
                                            <div {...getSuggestionItemProps(suggestion, { className, style })}>
                                                <span>{suggestion.description}</span>
                                            </div>
                                        )
                                    })}
                                </div> : null }
                            </div>
                        )}
                    </PlacesAutocomplete>

                    <div className="pos-absolute" onClick={ this.props.changeMapState }>
                        <a className="pointer map-btn">
                            <i className="fa fa-map-marker font-lg" aria-hidden="true"></i>
                        </a>
                    </div>

                </div>

                <div className="py-15">
                    <div className="flex-center-y">
                        <span className="color-grey50 w-600 mr-15">Inactive</span>
                        <SwitchToggle value={ switchToggleValue }
                                      name={this.props.name + '[' + this.props.index + '].is_active'}
                                      onChange={ this.props.setFieldValue }/>
                        <span className="color-primary w-600 ml-25">Active</span>
                    </div>
                </div>

                <div>
                    { map }
                </div>
            </div>
        );
    }
}

export default BranchLocation;



// WEBPACK FOOTER //
// ./src/components/Customer-administrator/BranchLocation.js